$(window).on('load resize', function() {
	
	var windowWidth = $(window).width();

	if (windowWidth >= 1038) {
		
		if ($('#mmpage-navi-content').css('display') === 'none') {
			$('#mmpage-navi-content').css('display', 'block');
		} 	
		
	}else{
		
		$('#mmpage-navi-title').off('click');
		$('#mmpage-navi-title').on('click', function() {
			$('#mmpage-navi-content').slideToggle();
		});

		
	}
});

